import { LoginFooter } from '@/components/layout/footer'
import { HeaderIcon } from '@/components/icons/header-icon'

export function ConfirmationLayout({
  children,
  headerOptions,
}: {
  children: React.ReactNode
  headerOptions?: React.ReactNode
}) {
  return (
    <div className="flex min-h-screen flex-col items-center bg-white">
      <div className="bg-checkout-black flex w-screen justify-center">
        <div className="flex w-full max-w-[1440px] flex-row p-4">
          <HeaderIcon />
        </div>
      </div>
      <div className="flex w-full flex-grow flex-col md:flex-row">
        {children}
      </div>
      <hr className="border-1 border-checkout-bk-op20 w-full" />
      <div className="mt-auto w-full max-w-[1440px] bg-[#F3F3F3] px-2 md:bg-transparent md:px-4">
        <LoginFooter />
      </div>
    </div>
  )
}
